import { Client } from '@nio-fe/liquor-client';

export class MateBackendClient extends Client {
  constructor() {
    super('', {
      underscoreRequestData: false,
      camelizeResponseData: false,
    });
  }
  getCoreData() {
    const ts = new Date().getTime().toString(36);
    return this.get(`/core?ts=${encodeURIComponent(ts)}`);
  }
  switchBrand(brand: string) {
    return this.post('/bff/api/brand/switch', { brand });
  }
  registerBrands(brands: string[]) {
    return this.post('/bff/api/brand/account-register-bind', { brands });
  }
}
